import { InitDataType } from 'hooks';
import { ErrorType } from 'services/server';
import { PlayerViewType, DisplayBannerT, PlayerSizesType, CreativeGalleryParams } from 'types/creative';
import { ShareUrlParamsType } from 'context';

// Type of Actions allowed
export enum AppActionTypes {
  SET_LOADING = 'SET_LOADING',
  SET_ERROR = 'SET_ERROR',
  SET_INITIAL_DATA = 'SET_INITIAL_DATA',
  SET_PLAYER_VIEW = 'SET_PLAYER_VIEW',
  SET_SUPERFRAME_LOADED = 'SET_SUPERFRAME_LOADED',
  SET_SCREEN_SIZE_CLASS = 'SET_SCREEN_SIZE_CLASS',
  SET_BANNER_ACTIVE = 'SET_BANNER_ACTIVE',
  SET_MAIN_CONTENT_REF = 'SET_MAIN_CONTENT_REF',
  SET_PLAYER_SIZE_FORMAT = 'SET_PLAYER_SIZE_FORMAT',
  SET_PARAMS = 'SET_PARAMS',
  SET_GALLERY_PARAMS = 'SET_GALLERY_PARAMS',
  SET_ACTIVE_CREATIVE_VIEW = 'SET_ACTIVE_CREATIVE_VIEW',
  SET_SIZE_CHANGER_LIST = 'SET_SIZE_CHANGER_LIST',
  SET_SHOW_BANNER_OPTIONS = 'SET_SHOW_BANNER_OPTIONS'
};

// Action Generator for setting creative, pass this to the useAppDispatch with payload
export const setLoading = (loading: boolean) => {
  return {
    type: AppActionTypes.SET_LOADING,
    payload: loading,
  };
};

export const setError = (error: ErrorType | null) => {
  return {
    type: AppActionTypes.SET_ERROR,
    payload: error,
  };
};

export const setInitialData = (data: InitDataType) => {
  return {
    type: AppActionTypes.SET_INITIAL_DATA,
    payload: data,
  };
};

export const setPlayerView = (playerView: PlayerViewType) => {
  return {
    type: AppActionTypes.SET_PLAYER_VIEW,
    payload: playerView,
  };
};

export const setSuperFrameLoaded = (loaded: boolean) => {
  return {
    type: AppActionTypes.SET_SUPERFRAME_LOADED,
    payload: loaded,
  };
};

export const setSmallScreen = (c: string) => {
  return {
    type: AppActionTypes.SET_SCREEN_SIZE_CLASS,
    payload: c,
  };
};

export const setBannerActive = (bannerData: DisplayBannerT) => {
  return {
    type: AppActionTypes.SET_BANNER_ACTIVE,
    payload: bannerData,
  };
};

export const setMainContentRef = (mainContentRef: HTMLDivElement | null) => {
  return {
    type: AppActionTypes.SET_MAIN_CONTENT_REF,
    payload: mainContentRef
  }
}

export const setPlayerSizeFormat = (format: PlayerSizesType) => {
  return {
    type:  AppActionTypes.SET_PLAYER_SIZE_FORMAT,
    payload: format,
  };
};

export const setParams = (params: ShareUrlParamsType) => {
  return {
    type:  AppActionTypes.SET_PARAMS,
    payload: params,
  };
};


export const setGalleryParams = (params: CreativeGalleryParams) => {
  return {
    type:  AppActionTypes.SET_GALLERY_PARAMS,
    payload: params,
  };
};

export const setCreativeViewSize = (params: any) => {
  return {
    type:  AppActionTypes.SET_ACTIVE_CREATIVE_VIEW,
    payload: params,
  };
};

export const setSizeChangerList = (params: any) => {
  return {
    type:  AppActionTypes.SET_SIZE_CHANGER_LIST,
    payload: params,
  };
};

export const setShowBannerOptions = (params: boolean) => {
  return {
    type:  AppActionTypes.SET_SHOW_BANNER_OPTIONS,
    payload: params,
  };
};